import {LabelSettings} from "@progress/kendo-angular-progressbar";

export interface ProgressBarData {
	processed: number;
	total: number;
}

export enum ProgressBarStatus {
	pending = <number>0,
	processing = <number>1,
	failed = <number>2,
	completed = <number>3
}
